export const LESSON_CONTROLS = Object.freeze([
  { id: 'adapt', label: 'Adapt' },
  { id: 'level', label: 'Level' },
  { id: 'repeat', label: 'Repeat' },
  { id: 'manoeuvres', label: 'Manoeuvres' },
  { id: 'minor', label: 'Minor' },
  { id: 'major', label: 'Major' },
  { id: 'observation', label: 'Observation' },
  { id: 'end-lesson', label: 'End Lesson' },
  { id: 'karen', label: 'Voice control' },
].map(Object.freeze));

export function controlAvailable(id, actions, disabled = {}) {
  return !disabled[id] && typeof actions?.[id] === 'function';
}
